import React from 'react'

export default () =>  (
  <div className="catalog">
    Catalog
  </div>
)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Report.js